;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	$doc.ready(function() {
		$('.main-checkout .btn-view-cart').on('click', function (event) {
		    var $this = $(this);
		    var $target = $('.btn-view-cart');
		    var count = $this.data('item-count');
		    var $targetText = $target.find('span');

		    $target.toggleClass('active');

		    $targetText.text(
		    	($this.hasClass('active')? 'Hide' : 'View') +  ' Cart (' + count + ')'
			);
		    
		    $('.order-summary .order-summary-body').toggleClass('expanded');
		    
		    event.preventDefault();
		});

		$('.cart-item').on('click', '.disabled', function(event) {
			event.preventDefault();
		});

		var isAutoSearching = false;
		var isSearchUpdated = false;

		function searchListener() {
			var $target = $(this);
			var val = $target.val().trim();
			var flag = val === '';

			if (isAutoSearching) {
				isSearchUpdated = true;
				return;
			}

			hideNewsletterSignup(true);
			hideSearchSection(flag);

			!flag && searchAutocomplete('.header-search-results', val);
		}

		var prevSearchFlag = true;

		function clickOutOfHeader(event) {
			var $header = $('.header');
			var $target = $(event.target);

			if ($header.find($target).length) {
				return;
			}

			hideSearchSection(true);
			hideNewsletterSignup(true);
		}

		function hideSearchSection(flag) {
			var $body = $('body');
			var $search = $('.search-new');
			var $clearBtn = $search.find('.search-clear-btn');
			var $searchSection = $('.header-search-wrapper');
			var $bodyOverlay = $('.body-overlay');

			$clearBtn.add($searchSection).add($bodyOverlay).toggleClass('hidden', flag);
			$search.toggleClass('open', !flag);

			if (prevSearchFlag !== flag) {
				$body[flag? 'off' : 'on']('click', clickOutOfHeader);
			}

			prevSearchFlag = flag;
		}

		var prevNewsletterFlag = true;

		function hideNewsletterSignup(flag) {
			var $body = $('body');
			var $newsletterSection = $('.header-newsletter-wrapper');
			var $bodyOverlay = $('.body-overlay');
			var $form = $newsletterSection.find('.subscribe-form');

			$newsletterSection.add($bodyOverlay).toggleClass('hidden', flag);
			!flag && $form.css('min-height', ($form.outerHeight() * 2 / 3) + 'px');

			if (prevNewsletterFlag !== flag) {
				$body[flag? 'off' : 'on']('click', clickOutOfHeader);
			}

			prevNewsletterFlag = flag;
		}

		function searchAutocomplete(topEl, term) {
			isAutoSearching = true;
			isSearchUpdated = false;

			if (!$(topEl).length) {
				isAutoSearching = false;
				return;
			}

			$(topEl).find('ul.header-search-list').html('<li>...loading</li>');

			var criteria = [];
			$.each(searchTermConverter(term).query, function (key, value) {
				criteria.push(key + ':' + value);
			});

			var query = criteria.join(' OR ');
			$.ajax({
				url: "/search/",
				cache: false,
				data: {
					wt: 'json',
					start: 0,
					rows: 1000,
					q: query
				},
				success: function (data) {
					var showMax = 5;
					data = $.parseJSON(data);
					filterHideOnCountries(data);
                    $(topEl).find('ul.header-search-list').html(data.response.numFound < 1? '<li>No results</li>' : '');
					$.each(data.response.docs, function (index, element) {
						if (index >= showMax) {
							return false;
						}

						var url = element.page_name_s;
						var label = element.product_name_t;

						if (typeof element.attr_product_type != undefined) {
							label = label + " " + element.attr_product_type;
						}

						$(topEl).find('ul.header-search-list').append('<li><a href="' + url + '">' + label + '</a></li>');
					});


					if (data.response.numFound > showMax) {
						$(topEl).find('ul.header-search-list').append('<li><a href="#" class="header-search-viewall-link">View All (' + data.response.numFound + ')</a></li>');
						$(topEl).find('.header-search-viewall-link').on('click', function (event) {
							event.preventDefault();
							$('.search-new form').submit();
						})
					}

					searchAutocompleteCallback(topEl);
				},
				error: function () {
					$(topEl).find('ul.header-search-list').html('');
					searchAutocompleteCallback(topEl);
				}
			});
		}

		function searchAutocompleteCallback(topEl) {
			setTimeout(function() {
				if (!isSearchUpdated) {
					isAutoSearching = false;
					return;
				}

				searchAutocomplete(topEl, $('.search-new .search-new-field').val());
			}, 100);
		}

		$('.search-new-field').on('keydown', function(event) {
			if (!(event.key === 'Enter' || event.keyCode === 13)) {
				return;
			}

			event.preventDefault();

			$(this).closest('.search-new').find('form').submit();
		}).on('focusin input', searchListener).trigger('input');

		$('.search-new-btn').on('click', function(event) {
			event.preventDefault();

			var $this 		= $(this),
				$search 	= $this.closest('.search-new'),
				$field 		= $search.find('.search-new-field');

			if(!$search.hasClass('open')) {
				$search.addClass('open');
				$field.focus();
			} else {
				$search.find('form').submit();
			}
		});

		$('.search-clear-btn').on('click', function(event) {
			event.preventDefault();

			var $target = $(this);
			var $search = $target.closest('.search-new');
			var $field = $search.find('.search-new-field');

			$field.val('').focus();
			$target.addClass('hidden');
		});

		$('.newsletter-signup').on('click', function(event) {
			event.preventDefault();

			var $newsletterSection = $('.header-newsletter-wrapper');

			hideSearchSection(true);
			hideNewsletterSignup(!$newsletterSection.hasClass('hidden'));
		});

		$('body').on('click', '.subscribe-form .form-close', function(event) {
			event.preventDefault();

			hideNewsletterSignup(true);
		});

		$('#acdcConfirmSubscribeButton').on('submit', function() {
			return $('#acdcConfirmSubscribe').prop('checked');
		});

		$('body').on('click', '.scroll-to', function(){
			event.preventDefault();

			var target = this.hash,
			$target = $(target);

			$('html, body').stop().animate({
			    'scrollTop': $target.offset().top
			}, 900);
		});


		$('.acf-map').each(function(){
			render_map( $(this) );
		});

		$('.search-trigger').on('click', function(event) {
			event.preventDefault();

			$(this).closest('.search-primary').toggleClass('open');
		});

		$(".userRegionSelect").dropdown();
		$(".map-select").dropdown();

		$('.modal-dismis').on('click', function(event) {
			event.preventDefault();

			$('.modal-pdp').removeClass('open');
		});
	});
})(jQuery, window, document);

